import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type TypeStudentAuthStore = {
  id: string | null
  name: string | null
  courseId: string | null
  courseName: string | null
  ra: string | null
  role: string | null
  college: string | null
  token: string | null
  refreshToken: string | null
  collegeLogo: string | null
  collegePage: string | null
  setToken: (token: string, refreshToken: string) => void
  setSession: (
    token: string,
    refreshToken: string,
    name: string,
    ra: string,
    courseId: string,
    college: string,
    courseName: string,
    role: string,
    id: string,
    collegeLogo: string,
    collegePage: string
  ) => void
  clearSession: () => void
}

export const useStudentSessionStore = create<TypeStudentAuthStore>()(
  persist(
    (set) => ({
      id: null,
      token: null,
      refreshToken: null,
      name: null,
      ra: null,
      courseId: null,
      college: null,
      courseName: null,
      role: null,
      collegeLogo: null,
      collegePage: null,
      setToken: (token, refreshToken) => set({ token, refreshToken }),
      setSession: (
        token,
        refreshToken,
        name,
        ra,
        courseId,
        college,
        courseName,
        role,
        id,
        collegeLogo,
        collegePage
      ) =>
        set({
          name,
          courseId,
          courseName,
          role,
          college,
          ra,
          token,
          id,
          refreshToken,
          collegeLogo,
          collegePage
        }),
      clearSession: () =>
        set({
          token: null,
          refreshToken: null,
          name: null,
          ra: null,
          courseId: null,
          courseName: null,
          college: null,
          role: null,
          id: null
        })
    }),
    {
      name: 'student-session'
    }
  )
)
